interface ColorFieldProps {
    label: string
    value: string
    onChange: (value: string) => void
    allowTransparent?: boolean
}

export default function ColorField({ label, value, onChange, allowTransparent }: ColorFieldProps) {
    const isTransparent = value === 'transparent' || value === ''

    return (
        <div>
            <div className="popup-field-label">{label}</div>
            <div className="popup-color-field">
                <input
                    type="color"
                    value={isTransparent ? '#ffffff' : (value || '#000000')}
                    onChange={e => onChange(e.target.value)}
                    disabled={isTransparent}
                />
                {allowTransparent && (
                    <button
                        type="button"
                        className={isTransparent ? 'active' : undefined}
                        onClick={() => onChange(isTransparent ? '#ffffff' : 'transparent')}
                    >
                        None
                    </button>
                )}
            </div>
        </div>
    )
}
